"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumsGuard = exports.enums = void 0;
var guard_1 = require("../guard");
var VALID_TYPES = ['bigint', 'boolean', 'number', 'string', 'symbol'];
/**
 * Constructs a type-guard for a enumerable
 * @param constants - array of possible literals for the enum
 */
function enums(constants) {
    return new EnumsGuard(constants);
}
exports.enums = enums;
var EnumsGuard = /** @class */ (function (_super) {
    __extends(EnumsGuard, _super);
    function EnumsGuard(constants) {
        var e_1, _a;
        var _this = this;
        if (Array.isArray(constants) === false) {
            throw new Error('"enums" must be an array of bigint, boolean, number, string or symbol');
        }
        try {
            for (var constants_1 = __values(constants), constants_1_1 = constants_1.next(); !constants_1_1.done; constants_1_1 = constants_1.next()) {
                var constant = constants_1_1.value;
                var type = typeof constant;
                if (VALID_TYPES.includes(type) === false || (type === 'number' && isNaN(constant))) {
                    throw new Error('"enums" must be an array of bigint, boolean, number, string or symbol');
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (constants_1_1 && !constants_1_1.done && (_a = constants_1.return)) _a.call(constants_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        _this = _super.call(this, {
            type: 'enums',
            validate: function (path, value) {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(constants.includes(value) === false)) return [3 /*break*/, 2];
                            return [4 /*yield*/, {
                                    path: path,
                                    rule: 'type',
                                    setting: constants,
                                    actual: value
                                }];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            }
        }) || this;
        _this.constants = constants;
        return _this;
    }
    EnumsGuard.prototype.pick = function (constants) {
        var omittedConstants = this.constants.filter(function (constant) { return constants.includes(constant); });
        return new EnumsGuard(omittedConstants);
    };
    EnumsGuard.prototype.pluck = function (constant) {
        return new EnumsGuard([constant]);
    };
    EnumsGuard.prototype.omit = function (constants) {
        var omittedConstants = this.constants.filter(function (constant) { return constants.includes(constant) === false; });
        return new EnumsGuard(omittedConstants);
    };
    EnumsGuard.prototype.merge = function (constants) {
        var mergedConstants = this.constants
            .concat(constants)
            .filter(function (constant, index, arr) { return arr.indexOf(constant) === index; });
        return new EnumsGuard(mergedConstants);
    };
    return EnumsGuard;
}(guard_1.Guard));
exports.EnumsGuard = EnumsGuard;
